// Import only essential modules for Tooltips and Audio
import { initializeTippy } from './modules/initializeTippy.js';
import { playHotspotAudio, stopAllAudio } from './modules/playAudio.js';
import { setTargetHotspot, tryActivateTargetTooltip } from './modules/tooltip-activator.js';

// Make functions available globally if needed by the skin
window.setTargetHotspot = setTargetHotspot;
window.playHotspotAudio = playHotspotAudio;
window.stopAllAudio = stopAllAudio;
window.initializeTippy = initializeTippy;

// Document ready handlers
$(document).ready(function() {
    // Initialize tooltips (if needed on initial static elements)
     if(typeof initializeTippy === 'function') initializeTippy();
     
    // Call the function that will wait for pano and attach listeners
    console.log("<<< PANO CustomJS: Initiating listener setup.");
    setupPanoListeners();
});

/**
 * Handles actions needed when the panorama node changes.
 */
function handleNodeChange() {
    // Ensure pano object is available
    if (!window.pano) {
        console.warn("<<< PANO CustomJS: handleNodeChange called but window.pano is not ready.");
        return;
    };
    console.log("<<< PANO CustomJS: changenode detected.");

    try {
        // 1. Stop any currently playing audio (Use globally exposed function)
        if(typeof window.stopAllAudio === 'function') {
            window.stopAllAudio();
        }

        // 2. Initialize Tippy for the new node's hotspots
        // Use requestAnimationFrame to allow DOM updates to settle
        requestAnimationFrame(() => {
            if(typeof window.initializeTippy === 'function') {
                window.initializeTippy();
                console.log("<<< PANO CustomJS: initializeTippy completed.");
            } else {
                 console.warn("<<< PANO CustomJS: initializeTippy function not found on window.");
            }
            
            // 3. Attempt to activate the target tooltip *after* Tippy init
            // Use another frame or slight delay for safety before calling the imported function
            requestAnimationFrame(() => { // Or setTimeout(tryActivateTargetTooltip, 10);
                try {
                    tryActivateTargetTooltip(); // Call the imported function
                } catch(e) { console.error("<<< PANO CustomJS: Error during tryActivateTargetTooltip:", e); }
            });
        });

    } catch(e) {
         console.error("<<< PANO CustomJS: Error during handleNodeChange sequence:", e);
    }
}

/**
 * Attaches event listeners to the pano object once it's ready.
 * Ensures listeners are attached only once.
 */
function setupPanoListeners() {
    // Check if pano exists, has the 'on' method, and listeners haven't been attached yet
    if (window.pano && typeof window.pano.on === 'function' && !window.panoListenersAttached) {
        console.log("<<< PANO CustomJS: Attaching Pano listeners.");
        
        window.pano.on('changenode', handleNodeChange);
        window.panoListenersAttached = true; // Set flag to prevent re-attaching

        // Trigger initial handling for the starting node as pano is ready now
        console.log("<<< PANO CustomJS: Triggering initial node handling.");
        handleNodeChange();

    } else if (!window.panoListenersAttached) {
        // If pano not ready yet, schedule a retry with short interval
        setTimeout(setupPanoListeners, 50); 
    }
}

// Try to setup listeners immediately (in case script loads after pano)
setupPanoListeners();

/**
 * Setup Deep Linking for Pano2VR for completely bundled functionality
 * Handles WordPress dataset attributes and Standalone browser hashes.
 */
function setupDeepLinking() {
    if (!window.pano || typeof window.pano.readConfigUrlAsync !== 'function') {
        setTimeout(setupDeepLinking, 50);
        return;
    }

    if (window.panoDeepLinkSetupDone) return;
    window.panoDeepLinkSetupDone = true;

    const originalReadConfigUrlAsync = window.pano.readConfigUrlAsync;

    // Override the config loading to run our deep-linking logic
    window.pano.readConfigUrlAsync = function (url, callback) {
        
        const customCallback = function () {
            // First call the original callback if it was provided
            if (typeof callback === 'function') {
                callback();
            }

            // Determine the source URL string
            let hashString = '';
            const container = document.getElementById("container");

            // 1. Attempt to read custom dataset attribute from DOM
            if (container && container.dataset && container.dataset.vtourLink) {
                const link = container.dataset.vtourLink;
                if (link && link.includes('#')) {
                    hashString = link.substring(link.indexOf('#'));
                }
            }

            // 2. Fall back to current URL hash
            if (!hashString || hashString.trim() === '' || hashString === '#') {
                hashString = window.location.hash;
            }

            // Parse parameters and apply
            if (hashString && hashString.startsWith('#')) {
                const paramsString = hashString.substring(1);
                const params = paramsString.split(',');
                
                if (params.length > 0 && params[0].trim() !== '') {
                    const nodeId = params[0].trim();
                    const pan = params.length > 1 ? parseFloat(params[1]) : NaN;
                    const tilt = params.length > 2 ? parseFloat(params[2]) : NaN;
                    const fov = params.length > 3 ? parseFloat(params[3]) : NaN;

                    // Apply nodeId (with brackets if required by pano2vr, standard format)
                    const formattedNodeId = nodeId.startsWith('{') ? nodeId : '{' + nodeId + '}';
                    window.pano.openNext(formattedNodeId);

                    // If coordinate variables exist, immediately apply them
                    if (!isNaN(pan) && !isNaN(tilt) && !isNaN(fov)) {
                        window.pano.setPanTiltFov(pan, tilt, fov);
                    }
                }
            }
        };

        // Trigger the original function with our wrapped callback
        originalReadConfigUrlAsync.call(window.pano, url, customCallback);
    };
}

setupDeepLinking();

